























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import { unrealizedColumns, currencyMap, permil, calValue } from '@/utils/finance';

@Component({
  components: {}
})
class UnrealizedTable extends Vue {
  unrealizedColumns: any[] = unrealizedColumns;
  unrealizedData: any[] = [];
  calValue = calValue;
  permil: any = permil;

  get unrealized() {
    return this.$store.state.middlePageDetail.unrealized;
  }

  @Watch('unrealized')
  initUnrealized(dataList) {
    let cnyTotalInfo: any = {
      investmentCost: 0,
      shareNum: 0, // 最新持有股数
      sharePercent: 0, // 最新持股占比
      fmv: 0, // 最新FMV
      sharePercentMultiLatestPostValuation: 0, // 持股占比*最新投后估值
      // moic: 0,// moic
      fmvsubInvestmentCost: 0 // 最新FMV - Investment Cost
    };
    let usdTotalInfo: any = {
      investmentCost: 0,
      shareNum: 0,
      sharePercent: 0,
      fmv: 0,
      sharePercentMultiLatestPostValuation: 0,
      // moic: 0,
      fmvsubInvestmentCost: 0
    };
    let { cnyPostValuation, usdPostValuation } = this.calPostValuation();
    let finalList = dataList.reduce((list, fundItem) => {
      let {
        currency,
        investmentCost,
        shareNum,
        sharePercent,
        fmv,
        penetrateProjectVos,
        adjust,
        fmvsubInvestmentCost,
        moic,
        sharePercentMultiLatestPostValuation
      } = fundItem;
      let fmvText = permil(fmv);
      let sharePercentMultiLatestPostValuationText = permil(sharePercentMultiLatestPostValuation);
      list.push({
        ...fundItem,
        currencyText: currencyMap[currency],
        investmentCostText: permil(investmentCost),
        shareNumText: permil(shareNum, 2, true),
        sharePercentText: (sharePercent * 100).toFixed(2) + '%',
        fmvText,
        sharePercentMultiLatestPostValuationText,
        moic: moic === null || moic === undefined ? '' : moic.toFixed(4),
        fmvsubInvestmentCost: fmvsubInvestmentCost,
        fmvChange: permil(adjust, 10, true),
        fmvSame: fmvText === sharePercentMultiLatestPostValuationText
      });
      if (currency === 1) {
        cnyTotalInfo.investmentCost = cnyTotalInfo.investmentCost + investmentCost;
        cnyTotalInfo.shareNum = cnyTotalInfo.shareNum + shareNum;
        cnyTotalInfo.sharePercent = cnyTotalInfo.sharePercent + sharePercent;
        cnyTotalInfo.fmv = cnyTotalInfo.fmv + fmv;
        cnyTotalInfo.sharePercentMultiLatestPostValuation = cnyTotalInfo.sharePercentMultiLatestPostValuation + sharePercentMultiLatestPostValuation;
        // cnyTotalInfo.moic = cnyTotalInfo.moic + moic;
        cnyTotalInfo.fmvsubInvestmentCost = cnyTotalInfo.fmvsubInvestmentCost + fmvsubInvestmentCost;
      } else if (currency === 2) {
        usdTotalInfo.investmentCost = usdTotalInfo.investmentCost + investmentCost;
        usdTotalInfo.shareNum = usdTotalInfo.shareNum + shareNum;
        usdTotalInfo.sharePercent = usdTotalInfo.sharePercent + sharePercent;
        usdTotalInfo.fmv = usdTotalInfo.fmv + fmv;
        usdTotalInfo.sharePercentMultiLatestPostValuation = usdTotalInfo.sharePercentMultiLatestPostValuation + sharePercentMultiLatestPostValuation;
        // usdTotalInfo.moic = usdTotalInfo.moic + moic;
        usdTotalInfo.fmvsubInvestmentCost = usdTotalInfo.fmvsubInvestmentCost + fmvsubInvestmentCost;
      }

      if (penetrateProjectVos.length > 0) {
        penetrateProjectVos.forEach(penetrateItem => {
          let { currency, investmentCost, shareNum, fmv, sharePercent, sharePercentMultiLatestPostValuation, moic, fmvsubInvestmentCost } = penetrateItem;
          let fmvText = permil(fmv);
          let sharePercentMultiLatestPostValuationText = permil(sharePercentMultiLatestPostValuation);
          let item = {
            penetrateFund: penetrateItem,
            currencyText: currency,
            investmentCostText: permil(investmentCost),
            shareNumText: permil(shareNum, 2, true),
            sharePercentText: (sharePercent * 100).toFixed(2) + '%',
            fmvText,
            sharePercentMultiLatestPostValuationText,
            fmvSame: fmvText === sharePercentMultiLatestPostValuationText,
            moic: moic === null || moic === undefined ? '' : moic.toFixed(4),
            fmvsubInvestmentCost: fmvsubInvestmentCost
          };
          list.push(item);
        });
      }
      return list;
    }, []);
    if (finalList.length > 0) {
      let cnyTotalItem, usdTotalItem;
      let cnyFmvText = permil(cnyTotalInfo.fmv);
      let cnySharePercentMultiLatestPostValuationText = permil(cnyTotalInfo.sharePercentMultiLatestPostValuation);
      cnyTotalItem = {
        classOfShare: '合计',
        currencyText: 'CNY',
        investmentCostText: permil(cnyTotalInfo.investmentCost),
        shareNumText: permil(cnyTotalInfo.shareNum, 2, true),
        sharePercentText: (cnyTotalInfo.sharePercent * 100).toFixed(2) + '%',
        fmvText: cnyFmvText,
        moic: +cnyTotalInfo.investmentCost ? (cnyTotalInfo.fmv / cnyTotalInfo.investmentCost).toFixed(4) : '',
        sharePercentMultiLatestPostValuationText: cnySharePercentMultiLatestPostValuationText,
        fmvSame: cnyFmvText === cnySharePercentMultiLatestPostValuationText,
        fmvsubInvestmentCost: cnyTotalInfo.fmvsubInvestmentCost
      };
      let usdFmvText = permil(usdTotalInfo.fmv);
      let usdSharePercentMultiLatestPostValuationText = permil(usdTotalInfo.sharePercentMultiLatestPostValuation);
      usdTotalItem = {
        classOfShare: '合计',
        currencyText: 'USD',
        investmentCostText: permil(usdTotalInfo.investmentCost),
        shareNumText: permil(usdTotalInfo.shareNum, 2, true),
        fmvText: usdFmvText,
        sharePercentText: (usdTotalInfo.sharePercent * 100).toFixed(2) + '%',
        moic: +usdTotalInfo.investmentCost ? (usdTotalInfo.fmv / usdTotalInfo.investmentCost).toFixed(4) : '',
        sharePercentMultiLatestPostValuationText: usdSharePercentMultiLatestPostValuationText,
        fmvSame: usdFmvText === usdSharePercentMultiLatestPostValuationText,
        fmvsubInvestmentCost: usdTotalInfo.fmvsubInvestmentCost
      };
      finalList.unshift(usdTotalItem);
      finalList.unshift(cnyTotalItem);
    }
    this.unrealizedData = finalList;
  }

  // 换算投后估值
  calPostValuation() {
    let { postValuation, currency: valueCurrency, bookRate } = this.$store.state.middlePageDetail.latest[0];
    let cnyPostValuation, usdPostValuation;
    if (valueCurrency === 1) {
      cnyPostValuation = postValuation;
      usdPostValuation = bookRate && (postValuation || postValuation === 0) ? postValuation / bookRate : null; // null是为了和未填写时返回的null一致
    } else {
      cnyPostValuation = bookRate && (postValuation || postValuation === 0) ? postValuation * bookRate : null;
      usdPostValuation = postValuation;
    }
    return { cnyPostValuation, usdPostValuation };
  }

  computerMath(num1, num2, type) {
    var baseNum, baseNum1, baseNum2;
    try {
      baseNum1 = num1.toString().split('.')[1].length;
    } catch (e) {
      baseNum1 = 0;
    }
    try {
      baseNum2 = num2.toString().split('.')[1].length;
    } catch (e) {
      baseNum2 = 0;
    }
    baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
    if (type === 'add') {
      return (num1 * baseNum + num2 * baseNum) / baseNum;
    } else if (type === 'minus') {
      let precision = baseNum1 >= baseNum2 ? baseNum1 : baseNum2;
      // 小数最多保留十位
      precision = precision > 10 ? 10 : precision;
      return ((num1 * baseNum - num2 * baseNum) / baseNum).toFixed(precision);
    }
  }

  toFMV(fund) {
    let { type, id } = fund;
    if (type !== 2) {
      window.open(`/finance/fairvalueTable?fundId=${id}`);
    } else {
      this.$message.warn('SPV无法跳转FMV');
    }
  }

  copyValue(value) {
    let oInput = document.createElement('input');
    oInput.value = value;
    document.body.appendChild(oInput);
    oInput.select(); // 选择对象;
    document.execCommand('Copy');
    this.$message.success('复制成功');
  }
}

export default UnrealizedTable;
